import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dailyFields', 'weeklyFields', 'monthlyFields', 'yearlyFields', 'monthSelect', 'daySelect']

  declare hasDailyFieldsTarget: boolean
  declare hasWeeklyFieldsTarget: boolean
  declare hasMonthlyFieldsTarget: boolean
  declare hasYearlyFieldsTarget: boolean
  declare hasMonthSelectTarget: boolean
  declare hasDaySelectTarget: boolean
  declare dailyFieldsTarget: HTMLElement
  declare weeklyFieldsTarget: HTMLElement
  declare monthlyFieldsTarget: HTMLElement
  declare yearlyFieldsTarget: HTMLElement
  declare monthSelectTarget: HTMLSelectElement
  declare daySelectTarget: HTMLSelectElement

  connect (): void {
    this.toggleVisibility(this.getFrequency())
    if (this.hasMonthSelectTarget) {
      this.updateDaysForMonth()
    }
  }

  toggle (event: Event): void {
    const target = event.target as HTMLSelectElement
    this.toggleVisibility(target.value)
  }

  updateDaysForMonth (event?: Event): void {
    if (!this.hasMonthSelectTarget || !this.hasDaySelectTarget) return

    const month = (event != null) ? (event.target as HTMLSelectElement).value : this.monthSelectTarget.value
    const daysInMonth = this.getDaysInMonth(parseInt(month))

    const currentDay = this.daySelectTarget.value

    this.daySelectTarget.innerHTML = ''
    for (let i = 1; i <= daysInMonth; i++) {
      const option = document.createElement('option')
      option.value = i.toString()
      option.textContent = this.ordinalize(i)
      this.daySelectTarget.appendChild(option)
    }

    if (currentDay !== null && currentDay !== '' && parseInt(currentDay) <= daysInMonth) {
      this.daySelectTarget.value = currentDay
    }
  }

  private getDaysInMonth (month: number): number {
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    return daysInMonth[month - 1]
  }

  private ordinalize (n: number): string {
    const s = ['th', 'st', 'nd', 'rd']
    const v = n % 100
    const index1 = (v - 20) % 10
    const index2 = v
    const suffix1 = index1 >= 0 && index1 < s.length ? s[index1] : ''
    const suffix2 = index2 >= 0 && index2 < s.length ? s[index2] : ''
    const suffix = suffix1 !== '' ? suffix1 : (suffix2 !== '' ? suffix2 : s[0])
    return `${n}${suffix}`
  }

  private getFrequency (): string {
    const select = this.element.querySelector("select[name*='frequency']")
    if (select !== null && select instanceof HTMLSelectElement) {
      return select.value
    }
    return ''
  }

  private toggleVisibility (value: string): void {
    const daily = this.hasDailyFieldsTarget ? this.dailyFieldsTarget : null
    const weekly = this.hasWeeklyFieldsTarget ? this.weeklyFieldsTarget : null
    const monthly = this.hasMonthlyFieldsTarget ? this.monthlyFieldsTarget : null
    const yearly = this.hasYearlyFieldsTarget ? this.yearlyFieldsTarget : null

    const map: Record<string, HTMLElement | null> = {
      daily,
      weekly,
      monthly,
      yearly
    }

    Object.entries(map).forEach(([key, el]) => {
      if (el !== null) {
        const show = value === key || (value === 'quarterly' && key === 'yearly')
        el.classList.toggle('hidden', !show)

        const inputs = el.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
          'input, select, textarea'
        )

        inputs.forEach(input => {
          if (show) {
            const originalName = input.dataset.originalName
            if (originalName !== undefined && originalName !== '') {
              input.setAttribute('name', originalName)
            }
            input.removeAttribute('disabled')
          } else {
            const name = input.getAttribute('name')
            if (name !== null && name !== '') {
              input.setAttribute('data-original-name', name)
            }
            input.removeAttribute('name')
            input.setAttribute('disabled', 'disabled')
          }
        })
      }
    })
  }
}
